import Axios from "axios";

import store from "@/store";

class ApiConnectorFormData {
  connector;

  constructor() {
    this.connector = Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: { "Content-Type": "multipart/form-data" },
    });

    this.connector.interceptors.request.use((config) => {
      const newConfig = { ...config };
      if (store && store.state.auth.token) {
        newConfig.headers.Authorization = `Bearer ${store.state.auth.token}`;
      }

      return newConfig;
    });
  }
}

export default new ApiConnectorFormData();
